import type { DomainSpecificConfig } from '../types';

const config: DomainSpecificConfig = {
  domains: [/^app\.magicschool\.ai/, /^app-magicschool-ai.translate.goog.*/, /^login\.magicschool\.ai/],
  domainType: 'school',
};

export default config;
